import React from "react";
import { contentTypes } from "../../data/mockData";
import { Megaphone, Layout, Video, Mail, Briefcase, Play, ArrowUpRight } from "lucide-react";

const iconMap = {
  megaphone: Megaphone,
  layout: Layout,
  video: Video,
  mail: Mail,
  briefcase: Briefcase,
  play: Play,
};

const ContentTypesSection = () => {
  return (
    <section className="py-28 relative">
      {/* Subtle glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-[radial-gradient(ellipse_at_center,_rgba(120,80,200,0.04)_0%,_transparent_70%)]" />

      <div className="relative max-w-[1200px] mx-auto px-6">
        <div className="text-center max-w-xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-white/[0.03] border border-white/[0.07] rounded-full px-4 py-1.5 mb-6">
            <span className="text-[11px] text-[#7a7a7a] uppercase tracking-widest font-medium">What you can save</span>
          </div>
          <h2 className="text-3xl md:text-[2.75rem] font-bold text-white tracking-[-0.02em] leading-tight mb-4">
            Save anything that inspires you.
          </h2>
          <p className="text-[#666] text-base leading-relaxed">
            Ads, landing pages, emails, UGC — all in one searchable library.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {contentTypes.map((type) => {
            const Icon = iconMap[type.icon];
            return (
              <div
                key={type.id}
                className="rounded-2xl border border-white/[0.06] bg-[#0a0a0c] p-7 group hover:border-white/[0.12] transition-all duration-500 hover:bg-[#0c0c0f] cursor-pointer relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-32 h-32 bg-[radial-gradient(circle,_rgba(120,80,200,0.04)_0%,_transparent_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="relative">
                  <div className="flex items-center justify-between mb-5">
                    <div className="w-11 h-11 rounded-xl bg-white/[0.04] border border-white/[0.08] flex items-center justify-center group-hover:bg-white/[0.06] transition-colors duration-300">
                      {Icon && <Icon size={20} className="text-white/50 group-hover:text-white/70 transition-colors" />}
                    </div>
                    <ArrowUpRight size={16} className="text-white/0 group-hover:text-white/30 transition-all duration-300 translate-y-1 group-hover:translate-y-0" />
                  </div>

                  <h3 className="text-white font-semibold text-[15px] mb-2 tracking-tight">{type.title}</h3>
                  <p className="text-[#555] text-[13px] leading-relaxed mb-4">{type.description}</p>
                  <span className="text-[11px] text-[#444] font-medium tracking-wide">{type.count}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContentTypesSection;
